<script lang="ts">
	const schema = JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'Bedales School',
		url: 'https://www.bedales.org.uk',
		logo: 'https://www.bedales.org.uk/favicons/favicon-light.png'
	})
</script>

<svelte:head>
	{@html `<script type="application/ld+json">${schema}</script>`}
</svelte:head>
